import { http } from "./api-config";
import store from "../store";

const apiClient = http(process.env.VUE_APP_AGENDA_SERVICE);
const apiConvocationClient = http(process.env.VUE_APP_CONVOCATION_SERVICE);
export default {
  async getMeetingList(data = null, isStatistics = false) {
    const filter = buildFilter(data, isStatistics);
    const headers = shouldUseSilentAPI(filter) ? { isSilentAPI: true } : {};
    store.commit("variables/setCashFilter", filter);
    const res = await apiClient.get("meetings", { params: filter, headers });

    return res.data;
  },
  async getMeetingListForCalendar(filter) {
    let headers = {};
    if (
      JSON.stringify(store.state.variables.cashCalendarFilter) ===
      JSON.stringify(filter)
    ) {
      headers = { isSilentAPI: true };
    }
    store.commit("variables/setCashCalendarFilter", filter);
    const res = await apiClient.get("meetings", { params: filter, headers });
    return res.data;
  },
  async getMeetingById(id, isSilentAPI) {
    let headers = {};
    if(isSilentAPI){
      headers = { isSilentAPI: true };
    }
    const res = await apiClient.get(`meeting/${id}`, { headers });
    return res.data;
  },
  async getShortMeetingById(id, isSilentAPI) {
    let headers = {};
    if(isSilentAPI){
      headers = { isSilentAPI: true };
    }
    const res = await apiClient.get(`meeting/${id}?votes-consent=true`, { headers });
    return res.data;
  },
  async createMeeting(meetingData) {
    const res = await apiClient.post("meeting", meetingData);
    return res.data;
  },
  async updateMeeting(meetingData) {
    const res = await apiClient.put("meeting", meetingData);
    return res.data;
  },
  async deleteMeeting(id) {
    const res = await apiClient.delete(`meeting/${id}`);
    return res.data;
  },
  async getConvocationContentById(id) {
    const res = await apiConvocationClient.get(`convocation/${id}`);
    return res.data;
  },
  async downloadConvocationMessage(id) {
    const res = await apiConvocationClient.get(`convocation/${id}`, {
      responseType: "blob",
    });
    return res;
  },
  async updateMeetingTopicVote(params) {
    const res = await apiClient.put("meetingvotes", params);
    return res.data;
  },
  async getMeetingTopicVote(meetingId, topicId) {
    const res = await apiClient.get(`meetingvotes/${meetingId}&${topicId}`);
    return res.data;
  },
  async getUserMeetingVotes(meetingId, isSilentAPI) {
    let headers = {};
    if(isSilentAPI){
      headers = { isSilentAPI: true };
    }
    const res = await apiClient.get(`usermeetingvotes/${meetingId}` , { headers });
    return res.data;
  },
  async getMeetingIDByType(meetingType) {
    const res = await apiClient.get(`meetings/${meetingType}`);
    return res.data;
  },
  async getUpcomingMeetingListByType(params) {
    const res = await apiClient.get("upcomingmeetinglist", { params });
    return res.data;
  },
  async createMeetingSeries(meetingData) {
    const res = await apiClient.post("meetingseries", meetingData);
    return res.data;
  },
  async deleteMeetingSeries(id) {
    const res = await apiClient.delete(`meetingseries/${id}`);
    return res.data;
  },
  async updateMeetingSeries(meetingData) {
    const res = await apiClient.put("meetingseries", meetingData);
    return res.data;
  },
  async getVotersDetails(meetingId) {
    const res = await apiClient.get(`votersdetails/${meetingId}`);
    return res.data;
  },
  async getMeetingVotersSummary(meetingId) {
    const res = await apiClient.get(`meetingvotes/${meetingId}`);
    return res.data;
  },
  async saveTags(payload) {
    const res = await apiClient.post("save_tags", payload);
    return res.data;
  },
  async getMomAssignees(meetingId) {
    const res = await apiClient.get(`mom_assignees/${meetingId}`);
    return res.data;
  },
  async getMomComments(meetingId) {
    const res = await apiClient.get(`momcomments/${meetingId}`);
    return res.data;
  },
  async storeMomComment(data) {
    const headers = { "Content-Type": "multipart/form-data" };
    const res = await apiClient.post("momcomment", data, {
      headers,
    });
    return res.data;
  },
  async updateMomComment(data) {
    const headers = { "Content-Type": "multipart/form-data" };
    const res = await apiClient.put("momcomment", data, {
      headers,
    });
    return res.data;
  },
  async deleteMomComment(id) {
    const res = await apiClient.delete(`momcomment/${id}`);
    return res.data;
  },
  async getMomcommentslog(meetingId) {
    const res = await apiClient.get(`momcommentslog/${meetingId}`);
    return res.data;
  },
  async momWansignDocumentReset(meetingId) {
    const res = await apiClient.get(`wansign_document_reset/${meetingId}`);
    return res.data;
  },
  async exportIcs(params) {
    const res = await apiClient.get("ics", { params });
    return res.data;
  },
  async updateMeetingAttendance(params) {
    const res = await apiClient.put("attendance", params);
    return res.data;
  },
  async validateMoveMeetingTopic(params) {
    const res = await apiClient.post("checktopicexist", params);
    return res.data;
  },
  async getMeetingFeedbacks(meetingId, isSilentAPI) {
    let headers = {};
    if(isSilentAPI){
      headers = { isSilentAPI: true };
    }
    const res = await apiClient.get(`meeting-feedbacks/${meetingId}`, { headers });
    return res.data.data;
  },
  async addMeetingTopicFeedback(feedback) {
    const { meetingId, ...updatedFeedback } = feedback;
    const res = await apiClient.post(`topic-feedbacks/${meetingId}`, updatedFeedback);
    return res.data.data;
  },
  async addAttendeeNote(note) {
    const res = await apiClient.put(`attendance-note`, note);
    return res.data;
  },
  async searchTags(payload) {
    const { tag, meetingTypeId } = payload;
      
    const params = new URLSearchParams({
      tag: tag || '',
      meeting_type_id: meetingTypeId
    });

    const response = await apiClient.get(`/search_tags?${params.toString()}`);
    return response.data;
  }

};

function buildFilter(data, isStatistics) {
  if (!data || !data.filter_type) return {};

  if (data.filter_type === "custom") {
    return isStatistics
      ? { filter_type: data.filter_type, from: data.start_date, to: data.end_date, page: "statistics" }
      : { filter_type: data.filter_type, from: data.start_date, to: data.end_date };
  }

  return { filter_type: data.filter_type };
}

function shouldUseSilentAPI(filter) {
  return JSON.stringify(store.state.variables.cashFilter) === JSON.stringify(filter);
}
